import React from "react";
import styles from "../WidgetAppearanceForm.module.css";
import {
    AppearanceTabSettingsContainer
} from "../../../../../../../elements/appearanceTabSettingsContainer/AppearanceTabSettingsContainer";
import {useAppDispatch} from "../../../../../../../../app/hooks";
import {ValidatedColorField} from "../../../../../../../elements/validator/component/ValidatedColorField";
import {ValidatedInputField} from "../../../../../../../elements/validator/component/ValidatedInputField";
import {ValidatedSelectField} from "../../../../../../../elements/validator/component/ValidatedSelectField";
import {SelectOption} from "../../../../../../../elements/select/SelectDropdown";
import {
    HexColorValidator,
    IntegerNumberValidator,
    NotEmptyStringValidator
} from "../../../../../../../elements/validator/Validator";
import {WidgetPosition} from "../../../../../../../../api/generated";
import {
    selectBrandColour,
    selectHidePoweredBy,
    selectHorizontalOffset,
    selectVerticalOffset,
    selectWidgetPosition,
    updateSettings
} from "../../../widgetAppearanceUpdateSlice";
import {
    CustomSwitchFieldWithTitle
} from "../../../../../../../elements/customSwitchFieldWithTitle/CustomSwitchFieldWithTitle";

const widgetPositionOptions: SelectOption<WidgetPosition>[] = [
    {label: "Bottom Left", value: WidgetPosition.Left},
    {label: "Bottom Right", value: WidgetPosition.Right}
];

interface GeneralSettingsProps {
    getMessageWrapper: (field: string) => string;
    updateValidationStatus: any;
}

export const GeneralSettings: React.FC<GeneralSettingsProps> = ({
                                                                    getMessageWrapper,
                                                                    updateValidationStatus
                                                                }) => {
    const dispatch = useAppDispatch();

    return (
        <AppearanceTabSettingsContainer title="General Settings">
            <div className={styles.fieldsLine}>
                <ValidatedColorField
                    onChange={(v) => dispatch(updateSettings({
                        brandColour: v
                    }))}
                    updateValidationStatus={updateValidationStatus}
                    fieldName="brandColour"
                    selector={selectBrandColour}
                    validator={HexColorValidator}
                    label="Brand colour"
                    getMessage={getMessageWrapper}
                />
            </div>
            <div className={styles.fieldsLine}>
                <ValidatedSelectField
                    onChange={(v) => dispatch(updateSettings({
                        widgetPosition: v
                    }))}
                    updateValidationStatus={updateValidationStatus}
                    fieldName="widgetPosition"
                    selector={selectWidgetPosition}
                    validator={NotEmptyStringValidator}
                    label="Chat Bubble Position"
                    getMessage={getMessageWrapper}
                    options={widgetPositionOptions}
                />
            </div>
            <div className={styles.fieldsLine}>
                <ValidatedInputField
                    onChange={(v) => {
                        const value = Number(v);
                        if (!isNaN(value)) {
                            dispatch(updateSettings({
                                horizontalOffsetPx: value
                            }));
                        }
                    }}
                    updateValidationStatus={updateValidationStatus}
                    fieldName="horizontalOffsetPx"
                    selector={selectHorizontalOffset}
                    validator={IntegerNumberValidator}
                    label="Move Widget Left/Right"
                    placeholder="e.g., 20"
                    getMessage={getMessageWrapper}
                    unit="px"
                    required={false}
                />
                <ValidatedInputField
                    onChange={(v) => {
                        const value = Number(v);
                        if (!isNaN(value)) {
                            dispatch(updateSettings({
                                verticalOffsetPx: value
                            }));
                        }
                    }}
                    updateValidationStatus={updateValidationStatus}
                    fieldName="verticalOffsetPx"
                    selector={selectVerticalOffset}
                    validator={IntegerNumberValidator}
                    label="Move Widget Top/Bottom"
                    placeholder="e.g., 20"
                    getMessage={getMessageWrapper}
                    unit="px"
                    required={false}
                />
            </div>
            <div className={styles.fieldsLine}>
                <CustomSwitchFieldWithTitle
                    textOnTrue={""}
                    textOnFalse={""}
                    title={"Powered By"}
                    description={'Hide "Powered By" from a widget footer'}
                    valueSelector={selectHidePoweredBy}
                    toggleValue={(v) => dispatch(updateSettings({
                        hidePoweredBy: v
                    }))}
                />
            </div>
        </AppearanceTabSettingsContainer>
    );
};
